import { Grid, Typography } from '@mui/material';
import { usePqrInitialCausality } from './hook';
import { PqrInitialCausalityProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const PqrInitialCausality = (props: PqrInitialCausalityProps) => {
    const { showTitle = true } = props;
    const {
        formik,
        products,
        motives,
        submotives1,
        submotives2,
        submotives3,
        submotives4,
    } = usePqrInitialCausality(props);

    const handleProductChangeLocal = (value: any) => {
        formik.setFieldValue('product', value);
        formik.setFieldValue('motive', '');
        formik.setFieldValue('submotive1', '');
        formik.setFieldValue('submotive2', '');
        formik.setFieldValue('submotive3', '');
        formik.setFieldValue('submotive4', '');

        (
            [
                'motive',
                'submotive1',
                'submotive2',
                'submotive3',
                'submotive4',
            ] as const
        ).forEach((k) => {
            formik.setFieldTouched(k, false, false);
            formik.setFieldError(k, undefined as any);
        });
    };

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            {showTitle && (
                <Grid item xs={12}>
                    <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                        Causalidad Inicial
                    </Typography>
                </Grid>
            )}
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(products)}
                    label="Producto"
                    name="product"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.product}
                    errors={formik.errors.product}
                    value={formik.values.product}
                    onChangeValue={(value: any) =>
                        props.onProductChange
                            ? props.onProductChange(value)
                            : handleProductChangeLocal(value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(motives)}
                    label="Motivo"
                    name="motive"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.motive}
                    errors={formik.errors.motive}
                    value={formik.values.motive}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('motive', value)
                    }
                />
            </Grid>
            {submotives1.length > 0 && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(submotives1)}
                        label="Submotivo 1"
                        name="submotive1"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.submotive1}
                        errors={formik.errors.submotive1}
                        value={formik.values.submotive1}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('submotive1', value)
                        }
                    />
                </Grid>
            )}
            {submotives2.length > 0 && submotives1.length > 0 && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(submotives2)}
                        label="Submotivo 2"
                        name="submotive2"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.submotive2}
                        errors={formik.errors.submotive2}
                        value={formik.values.submotive2}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('submotive2', value)
                        }
                    />
                </Grid>
            )}
            {submotives3.length > 0 && submotives2.length > 0 && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(submotives3)}
                        label="Submotivo 3"
                        name="submotive3"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.submotive3}
                        errors={formik.errors.submotive3}
                        value={formik.values.submotive3}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('submotive3', value)
                        }
                    />
                </Grid>
            )}
            {submotives4.length > 0 && submotives3.length > 0 && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(submotives4)}
                        label="Submotivo 4"
                        name="submotive4"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.submotive4}
                        errors={formik.errors.submotive4}
                        value={formik.values.submotive4}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('submotive4', value)
                        }
                    />
                </Grid>
            )}
        </Grid>
    );
};
